import React from 'react';
import MemberDetail from './index';

const MemberOnboardingSnapshot: React.FC = () => {
  return <MemberDetail section="onboarding-snapshot" />;
};

MemberOnboardingSnapshot.displayName = 'MemberOnboardingSnapshot';
export default MemberOnboardingSnapshot;
